export default function() {
    let textarea = document.querySelector('.wpcf7 textarea');

    if (textarea) {
        textarea.setAttribute('rows', '6');
    }
}
